import './geozone-popup.sass';
import { convertCoordinatesToLatLngLiteralArray } from '../../../utils/utils';
import { prettyFloat } from 'utils';
function getArea(area) {
    if (!area)
        return { km: null, ha: null };
    return {
        km: prettyFloat(area * 0.000001, 3) + ' км²',
        ha: prettyFloat(area * 0.0001, 1) + ' Га',
    };
}
function geodesicArea(latLngs) {
    let pointsCount = latLngs.length, area = 0.0, d2r = Math.PI / 180, p1, p2;
    if (pointsCount > 2) {
        for (let i = 0; i < pointsCount; i++) {
            p1 = latLngs[i];
            p2 = latLngs[(i + 1) % pointsCount];
            area +=
                (p2.lng - p1.lng) *
                    d2r *
                    (2 + Math.sin(p1.lat * d2r) + Math.sin(p2.lat * d2r));
        }
        area = (area * 6378137.0 * 6378137.0) / 2.0;
    }
    return Math.abs(area);
}
export function geozonePopup(layer) {
    const num_area = geodesicArea(
    // @ts-ignore
    convertCoordinatesToLatLngLiteralArray(layer.feature?.geometry.coordinates));
    const pi_R_2 = Math.PI *
        // @ts-ignore
        layer.feature.properties.radius *
        // @ts-ignore
        layer.feature.properties.radius;
    const area = getArea(num_area === 0 ? pi_R_2 : num_area);
    return ('<div class="ui-map-draw-geozone-popup-window">' +
        '<h1 class="ui-map-draw-geozone-popup-name"> ' +
        // @ts-ignore
        (layer.feature.properties.name ?? '') +
        '</h1>' +
        // @ts-ignore
        (layer.feature.properties.description !== ''
            ? '<h2 class="ui-map-draw-geozone-popup"> ' +
                // @ts-ignore
                layer.feature.properties.description +
                '</h2>'
            : '') +
        (area.ha != null
            ? '<hr />' +
                '<h2 class="ui-map-draw-geozone-popup"> ' +
                ('Площадь: ' + area.km + ' (' + area.ha + ')') +
                '</h2>'
            : '') +
        '</div>');
}
